import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Footer } from "@/components/Footer";
import { ARCANES } from "@/data/tarot";
import { C } from "@/pages/Blog";
import { usePageMeta } from "@/lib/seo";

const CardTile = ({ a, i }) => (
  <motion.li initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: Math.min(i * 0.03, 0.5) }}>
    <Link
      to={`/arcanes/${a.slug}`}
      data-testid={`arcane-tile-${a.slug}`}
      className="group block rounded-xl border p-3 h-full transition-colors hover:border-[rgba(230,198,135,0.45)]"
      style={{ borderColor: "rgba(230,198,135,0.15)", backgroundColor: "rgba(255,255,255,0.025)" }}
    >
      <img src={a.image} alt={`${a.name}, Tarot de Marseille`} loading="lazy" className="w-full aspect-[2/3] object-cover rounded-lg transition-transform duration-500 group-hover:scale-[1.02]" />
      <p className="font-body text-[10px] uppercase tracking-[0.2em] mt-3" style={{ color: C.goldLine }}>{a.numeral}</p>
      <h2 className="font-display text-lg leading-tight mt-1 group-hover:text-[#E6C687] transition-colors" style={{ color: C.title }}>{a.name}</h2>
    </Link>
  </motion.li>
);

export default function Arcanes() {
  usePageMeta({
    title: "Les 22 arcanes majeurs du Tarot de Marseille en amour | La Petite Boîte Intuitive",
    description: "La signification des 22 arcanes majeurs du Tarot de Marseille, en amour et dans tes tirages, racontée simplement par Lucie.",
    path: "/arcanes",
  });

  return (
    <div className="relative min-h-screen flex flex-col" style={{ backgroundColor: C.bg }}>
      <div className="oracle-bg" />
      <div className="relative z-10 flex-1 max-w-5xl w-full mx-auto px-6 py-14 sm:py-20">
        <Link to="/" data-testid="arcanes-back-link" className="inline-flex items-center gap-2 font-body text-xs tracking-[0.12em] uppercase mb-12 transition-colors hover:text-[#E6C687]" style={{ color: C.mist }}>
          <ArrowLeft size={14} strokeWidth={1.6} />
          Retour à l'accueil
        </Link>
        <div className="text-center">
          <p className="font-body uppercase tracking-[0.35em] text-xs" style={{ color: C.mist }}>Tarot de Marseille</p>
          <h1 className="font-display uppercase tracking-[0.06em] text-4xl sm:text-5xl font-light mt-4" style={{ color: C.title }}>Les 22 arcanes majeurs</h1>
          <span className="block mx-auto my-7 h-px w-16" style={{ backgroundColor: "rgba(230,198,135,0.4)" }} />
          <p className="font-body text-base leading-relaxed max-w-xl mx-auto" style={{ color: C.body }}>
            Ce que chaque lame te dit, en amour et dans tes tirages. Simplement, sans détour.
          </p>
        </div>
        <ul data-testid="arcanes-grid" className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
          {ARCANES.map((a, i) => <CardTile key={a.slug} a={a} i={i} />)}
        </ul>
      </div>
      <Footer />
    </div>
  );
}
